import React from "react";

export default function OneItem({product}) {
    return (<>
        <div className="recom-slider-title">Товар успешно добавлен в корзину</div>
        <img style={{
            height: '250px',
            margin: 'auto',
            display: 'block',
            objectFit: 'contain',
        }} src={product.imageUrl}/>
    </>);
}